import TourModal from './TourModal';

export default TourModal;
